import { useLocation } from 'react-router-dom';

import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useSampleInfoQuestions from 'services/surveys/useSampleInfoQuestions';

import {
  Card,
  LinkButton,
  ButtonVariants,
  ButtonSizes,
  ButtonColors,
} from 'components';
import { Icon, Typography } from '@repo/ui';

export const SampleInfoAnswersCard = () => {
  const { pathname } = useLocation();
  const { currentKit, currentKitId, currentTinyAccountId } =
    useCurrentKitAndTinyAccount();
  const { needsSampleInfo } = useSampleInfoQuestions(
    currentTinyAccountId,
    currentKitId,
  );

  return (
    <Card id={'sampleInfoCard'} variant='wrapper' className='p-3'>
      <div className='flex flex-column gap-3'>
        <div className='flex flex-column gap-2'>
          <div className='flex align-items-center justify-content-between gap-1 w-100'>
            <Typography variant='heading-m'>Sample info</Typography>
            {!needsSampleInfo && (
              <div className='flex align-items-center gap-1'>
                <Icon name='check' size='m' active />
              </div>
            )}
          </div>
          {/* <Typography variant='body-s' className='grey-text'>
            A few questions about what was going on at the time of sampling.
          </Typography> */}
        </div>

        <div className='flex align-items-center justify-content-between gap-1 w-100'>
          {needsSampleInfo ? (
            <LinkButton
              label={'Get started'}
              href={`/profile?kit=${currentKitId}`}
              state={{ from: pathname }}
              variant={ButtonVariants.SOLID}
              size={ButtonSizes.S}
              color={ButtonColors.PURPLE}
            />
          ) : (
            <LinkButton
              label='View response'
              href={`/results/${currentKitId}/surveys/sample`}
              state={{ from: pathname }}
              variant={ButtonVariants.TEXT}
              size={ButtonSizes.S}
              color={ButtonColors.PURPLE}
            />
          )}
          {!currentKit?.date_results_ready && (
            <LinkButton
              label='Edit answers'
              href={`/profile/${currentKitId}/edit?flow=sampleinfo`}
              state={{ from: pathname }}
              variant={ButtonVariants.TEXT}
              size={ButtonSizes.S}
              color={ButtonColors.PURPLE}
            />
          )}
        </div>
      </div>
    </Card>
  );
};
